/*
 * Saga to join selected channel if it wasn't previously
 */

import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import get from 'lodash/get';

import {
  activeTargetUserChannelSelector,
  chatModuleInstanceSelector,
  nextActiveTargetUserChannelSelector,
  activeSocialChannelSelector,
} from '../selectors';
import { drawerVisibleSelector } from '../../ui/selectors';
import { consts as drawer } from '../../ui/drawer';
import chatConsts from '../constants';
import { isDesktop } from '../../../utils/mobileHelpers';
import { ACTIVITIES_CHANNEL } from '../../../constants/chat';
import { APPOINTMENT_CHANNEL_ID } from '../../../constants';

function* toggleDrawer() {
  // close left sidebar for mobile devices
  const drawerVisible = yield select(drawerVisibleSelector);
  if (!isDesktop() && drawerVisible) {
    yield put({ type: drawer.TOGGLE_VISIBILITY });
  }
}

function* connectToChannelWorker(action) {
  const state = yield select();
  if (action.payload === APPOINTMENT_CHANNEL_ID) {
    yield toggleDrawer();
    yield cancel();
  }
  const chatModuleInstance = chatModuleInstanceSelector(state);
  const activeTargetUserChannel = activeTargetUserChannelSelector(state);
  const { channelName } = nextActiveTargetUserChannelSelector(state) || {};
  let unread;

  if (activeTargetUserChannel) {
    const channelInstance = chatModuleInstance.getCircle(
      activeTargetUserChannel.channelId,
    );

    unread = activeTargetUserChannel.unreadCount;
    if (get(channelInstance, 'currentPage') === 0) {
      channelInstance.loadNextHistoryPage();
    }
  } else {
    // initialize new CircleOfCare instance
    // TODO REFACTOR

    let channelId;
    let unreadCount;

    if (nextActiveTargetUserChannelSelector(state)) {
      const { channelId: id, totalUnreadCount: count } =
        nextActiveTargetUserChannelSelector(state) || {};
      channelId = id;
      unreadCount = count;
    }

    if (activeSocialChannelSelector(state)) {
      const { channelId: id, totalUnreadCount: count } =
        activeSocialChannelSelector(state) || {};
      channelId = id;
      unreadCount = count;
    }

    unread = unreadCount;
    if (!channelId) return;

    const channelInstance = chatModuleInstance.createChannel(channelId, {
      unreadCount,
    });
    channelInstance.loadNextHistoryPage();
  }

  yield toggleDrawer();

  const id = action.payload;

  if (id) {
    yield put({
      type: chatConsts.ADD_ACTIVE_UNREAD,
      payload: unread,
    });

    if (channelName !== ACTIVITIES_CHANNEL) {
      yield put({
        type: chatConsts.BUMP_ACTIVITY,
        payload: id,
      });
    }
  }
}

export default function* connectToChannelSaga() {
  yield takeLatest([chatConsts.SET_ACTIVE_CHANNEL_ID], connectToChannelWorker);
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/connectToChannel.js